module.exports = __webpack_public_path__ + "img/g3.8f1d2e21.jpg";